export default "__VITE_ASSET__58e8afbb__"